import styles from "./deliveryTableLoader.module.css";

/**
 * Skeleton loader for the Driver Job Delivery page.
 * Mirrors the real layout (filter bar + table on desktop, cards on mobile)
 * so the page doesn't jump/reflow once data arrives.
 */
const DeliveryTableLoader = ({ rows = 6 }) => {
    const rowArray = Array.from({ length: rows });

    return (
        <div className={styles.LoaderWrap} aria-busy="true" aria-label="Loading deliveries">
            {/* Filter bar skeleton */}
            <div className={styles.FilterRow}>
                <div className={`${styles.Bar} ${styles.SearchBar}`} />
                <div className={styles.FilterActions}>
                    <div className={`${styles.Bar} ${styles.PillBar}`} />
                    <div className={`${styles.Bar} ${styles.PillBar}`} />
                </div>
            </div>

            {/* Desktop table skeleton */}
            <div className={styles.TableSkeleton}>
                <div className={styles.TableHeadRow}>
                    {Array.from({ length: 8 }).map((_, i) => (
                        <div key={i} className={`${styles.Bar} ${styles.HeadCell}`} />
                    ))}
                </div>
                {rowArray.map((_, i) => (
                    <div key={i} className={styles.TableBodyRow}>
                        <div className={`${styles.Bar} ${styles.Checkbox}`} />
                        <div className={`${styles.Bar} ${styles.Cell}`} />
                        <div className={`${styles.Bar} ${styles.CellShort}`} />
                        <div className={`${styles.Bar} ${styles.Cell}`} />
                        <div className={`${styles.Bar} ${styles.CellShort}`} />
                        <div className={`${styles.Bar} ${styles.Cell}`} />
                        <div className={`${styles.Bar} ${styles.Chip}`} />
                        <div className={`${styles.Bar} ${styles.CellShort}`} />
                    </div>
                ))}
            </div>

            {/* Mobile card skeleton */}
            <div className={styles.CardSkeleton}>
                {rowArray.slice(0, 4).map((_, i) => (
                    <div key={i} className={styles.CardBlock}>
                        <div className={styles.CardTop}>
                            <div className={`${styles.Bar} ${styles.CardTitle}`} />
                            <div className={`${styles.Bar} ${styles.Chip}`} />
                        </div>
                        <div className={`${styles.Bar} ${styles.CardLine}`} />
                        <div className={`${styles.Bar} ${styles.CardLineShort}`} />
                    </div>
                ))}
            </div>
        </div>
    );
};

export default DeliveryTableLoader;